import { getClientDetailsApi } from '../generated/clients/getClientDetails';

const clientDetailsApi = getClientDetailsApi.enhanceEndpoints({
  endpoints: {
    getClientDetails: {
      providesTags: (_result, _error, { clientId }) => [{ id: clientId, type: 'Clients' as const }],
    },
  },
});

export const { useGetClientDetailsQuery } = clientDetailsApi;
export { clientDetailsApi as getClientDetailsApi };
